<template>
  <!-- FIRST TIME ORDER SPECIAL – Tailwind HTML -->
  <section class="overflow-hidden relative bg-black">

    <div class="flex justify-center">
      <div class="px-8 py-3 lg:text-lg text-base md:px-16 md:py-4 md:text-xl font-ww-bold font-bold uppercase tracking-wide text-white
           bg-[#C40000]
           [clip-path:polygon(0_0,100%_0,calc(100%-24px)_100%,24px_100%)]">
        {{ bannerText }}
      </div>
    </div>


    <div class="px-4 pt-10 pb-12 mx-auto max-w-6xl md:px-6 md:pb-16">

      <!-- headline -->
      <h3 class="text-2xl text-center text-white xl:leading-10 font-ww-bold xl:text-42 md:text-3xl xl:px-8"
        v-html="mainHeading">
      </h3>
      <div class="md:mt-12 mt-6 text-base md:!leading-10 text-center text-white md:text-lg font-ww-regular xl:px-20"
        v-html="introText">
      </div>

      <div
        class="grid grid-cols-1 gap-x-4 mt-10 sm:grid-cols-2 md:grid-cols-12 xl:grid-cols-12 md:gap-x-3 lg:gap-x-6 xl:px-16 md-max:gap-y-4">
        <!-- Dynamic Bonus Cards -->
        <div v-for="(bonus, index) in bonuses" :key="index"
          :class="(bonus as any).colSpan || 'md:col-span-4 xl:col-span-4 '" class="">
          <div class="overflow-hidden relative lg:min-h-auto md:min-h-[420px] sm:min-h-[400px] min-h-[384px]">
            <div class="mb-2 text-base tracking-wider text-right text-white opacity-50 md:text-lg">
              BONUS
            </div>

            <div class="sm-max:visible md:hidden md:invisible">
              <svg class="w-full h-full" width="478" height="440" viewBox="0 0 478 440" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M477.5 0.5V439.5H0.5V0.5H477.5Z" fill="url(#paint0_linear_2754_21491)"
                  stroke="url(#paint1_linear_2754_2149)" />
                <defs>
                  <linearGradient id="paint0_linear_2754_21491" x1="239" y1="0" x2="239" y2="440"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#333333" />
                    <stop offset="1" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_2754_21491" x1="460.494" y1="6.49999" x2="300.122" y2="414.173"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#C4E538" />
                    <stop offset="1" />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            <div class="sm-max:invisible sm-max:hidden">

     


              <svg v-if="index === 0 || index === 1 || index === 2" class="w-full h-full" width="315"
                height="440" viewBox="0 0 315 440" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M314.5 0.5V439.5H0.5V0.5H314.5Z" :fill="`url(#paint0_linear_bonus_${index})`"
                  :stroke="`url(#paint1_linear_bonus_${index})`" />
                <defs>
                  <linearGradient :id="`paint0_linear_bonus_${index}`" x1="157.5" y1="0" x2="157.5" y2="440"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#333333" />
                    <stop offset="1" />
                  </linearGradient>
                  <linearGradient :id="`paint1_linear_bonus_${index}`" x1="303.463" y1="6.49999" x2="96.2754"
                    y2="353.581" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#C4E538" />
                    <stop offset="1" />
                  </linearGradient>
                </defs>
              </svg>

              <svg v-else class="w-full h-full" width="478" height="440" viewBox="0 0 478 440" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M477.5 0.5V439.5H0.5V0.5H477.5Z" fill="url(#paint0_linear_2754_2149)"
                  stroke="url(#paint1_linear_2754_2149)" />
                <defs>
                  <linearGradient id="paint0_linear_2754_2149" x1="239" y1="0" x2="239" y2="440"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#333333" />
                    <stop offset="1" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_2754_2149" x1="460.494" y1="6.49999" x2="300.122" y2="414.173"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#C4E538" />
                    <stop offset="1" />
                  </linearGradient>
                </defs>
              </svg>


            </div>
            <div class="absolute inset-0 z-10 pt-6 pl-4 md:pt-10 lg:pl-8">

              <div class="flex justify-end mt-2 md:-mt-1">
                <svg class="w-12 h-14 xl:w-16 xl:h-[73px]" width="64" height="73" viewBox="0 0 64 73" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M36.8455 73L64 73V0H0L36.8455 73Z" fill="#C4E538" />
                  <path v-if="(bonus as any).numberSvgPath" :d="(bonus as any).numberSvgPath" fill="black" />
                </svg>
              </div>

              <div class="-mt-8 text-lg text-white xl:-mt-10 xl:text-2xl lg:text-xl md:text-lg font-ww-bold"
                v-html="(bonus as any).title">
              </div>

              <div class="flex gap-x-2 items-center mt-2 md:gap-x-4 md:mt-4">
                <div
                  class="bg-[#F3A9B3] font-ww-bold text-base xl:text-lg w-fit py-1.5 px-3 md:py-1.5 xl:py-2 md:px-2 lg:px-4">
                  value: {{ (bonus as any).value }}
                </div>

                <!-- App Store Links (if exists) -->
                <template v-if="(bonus as any).appStoreLink">
                  <div>
                    <a :href="(bonus as any).appStoreLink" target="_blank" aria-label="Download on App Store">
                      <svg class="w-8 h-8 md:w-10 md:h-10" width="42" height="42" viewBox="0 0 42 42" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect width="42" height="42" rx="4.8704" fill="#4B4B4B" />
                        <path
                          d="M21.9851 11.4022C21.7164 11.4808 21.3366 11.5414 20.8509 11.5844C20.8728 10.5175 21.1552 9.59723 21.7025 8.82489C22.2398 8.05752 23.1473 7.52731 24.4267 7.23438C24.4347 7.25489 24.445 7.29595 24.4548 7.35297C24.4647 7.40999 24.4746 7.4491 24.4827 7.47063C24.4827 7.49897 24.4846 7.53518 24.4886 7.57816C24.4906 7.62152 24.4926 7.65672 24.4926 7.68633C24.4926 8.12301 24.387 8.60923 24.1763 9.14625C23.9593 9.68327 23.6208 10.1773 23.1632 10.6283C22.7712 11.0141 22.3771 11.2728 21.9851 11.4022ZM26.8704 18.9308C26.3691 18.223 26.1184 17.4233 26.1184 16.5357C26.1184 15.7262 26.3533 14.9851 26.8267 14.3129C27.0815 13.9463 27.4954 13.5249 28.0704 13.045C27.6923 12.5862 27.3144 12.2297 26.9363 11.9709C26.2517 11.5062 25.4775 11.2729 24.612 11.2729C24.0965 11.2729 23.4676 11.3944 22.7274 11.6375C22.0152 11.8826 21.4937 12.0028 21.1672 12.0028C20.9204 12.0028 20.4191 11.8963 19.6628 11.6809C18.8988 11.4658 18.256 11.3592 17.7326 11.3592C16.4809 11.3592 15.45 11.8744 14.6341 12.9055C13.8123 13.9502 13.4023 15.2909 13.4023 16.9215C13.4023 18.6565 13.9377 20.4556 15.0063 22.3254C16.0889 24.1796 17.1834 25.1067 18.2878 25.1067C18.658 25.1067 19.1394 24.9851 19.7267 24.7421C20.3156 24.5052 20.833 24.3872 21.2766 24.3872C21.7485 24.3872 22.2977 24.5019 22.9224 24.7303C23.5831 24.9597 24.0926 25.0741 24.4489 25.0741C25.3803 25.0741 26.3133 24.3728 27.2526 22.9693C27.8617 22.0745 28.3093 21.1799 28.5938 20.2851C27.945 20.0909 27.372 19.6402 26.8704 18.9308Z"
                          fill="white" />
                        <path
                          d="M15.5532 34.5957V29.5914H16.3896L17.9624 33.6735L19.5208 29.5914H20.3573V34.5957H19.6853V30.964L18.2555 34.5957H17.655L16.2252 30.964V34.5957H15.5532ZM23.3226 34.1024C24.0303 34.1024 24.5093 33.5305 24.5093 32.8085C24.5093 32.0864 24.0303 31.5145 23.3226 31.5145C22.6077 31.5145 22.1358 32.0864 22.1358 32.8085C22.1358 33.5305 22.6077 34.1024 23.3226 34.1024ZM23.2582 34.6815C22.1716 34.6815 21.4853 33.8522 21.4853 32.8085C21.4853 31.7647 22.2145 30.9354 23.2582 30.9354C23.873 30.9354 24.2805 31.2357 24.4592 31.4716L24.5522 31.0212H25.0955V34.5957H24.5522L24.4592 34.1167C24.2591 34.4098 23.7944 34.6815 23.2582 34.6815ZM27.9293 34.6815C26.8498 34.6815 26.1349 33.8522 26.1349 32.8085C26.1349 31.7647 26.8498 30.9354 27.9293 30.9354C28.637 30.9354 29.2089 31.2571 29.4877 31.8934L28.9158 32.1508C28.7156 31.7576 28.4154 31.5145 27.9078 31.5145C27.2573 31.5145 26.7854 32.0507 26.7854 32.8085C26.7854 33.5663 27.2573 34.1024 27.9293 34.1024C28.4511 34.1024 28.8014 33.7879 28.9516 33.459L29.5163 33.7164C29.2518 34.2383 28.7156 34.6815 27.9293 34.6815Z"
                          fill="white" />
                      </svg>
                    </a>
                  </div>
                </template>

                <template v-if="(bonus as any).playStoreLink">
                  <div>
                    <a :href="(bonus as any).playStoreLink" target="_blank" aria-label="Download on Google Play">
                      <svg class="w-8 h-8 md:w-10 md:h-10" width="42" height="42" viewBox="0 0 42 42" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect width="42" height="42" rx="4.8704" fill="#4B4B4B" />
                        <path
                          d="M13.4062 23.1065L19.8212 24.0357V17.8982H13.4062V23.1065ZM13.4062 17.0214H19.8212V10.8833L13.4062 11.8124V17.0214ZM20.698 24.1628L29.3056 25.4095V17.8982H20.698V24.1628ZM20.698 10.7558V17.0214H29.3056V9.50977L20.698 10.7558Z"
                          fill="white" />
                        <path
                          d="M8.25934 34.5957L6.45066 29.5914H7.17985L8.62394 33.6949L9.203 32.0721L8.30939 29.5914H8.95279L9.5247 31.2571L10.0895 29.5914H10.7257L9.85356 32.0507L10.4326 33.6949L11.8767 29.5914H12.5773L10.7901 34.5957H10.0966L9.5247 32.8943L8.95994 34.5957H8.25934ZM13.1705 30.292V29.5914H13.8854V30.292H13.1705ZM13.2134 34.5957V31.0212H13.8496V34.5957H13.2134ZM15.1823 34.5957V31.0212H15.7185L15.8114 31.4645C16.0259 31.1428 16.3833 30.9354 16.8981 30.9354C17.7917 30.9354 18.2349 31.5288 18.2349 32.4439V34.5957H17.5986V32.5011C17.5986 31.8648 17.2555 31.5145 16.7622 31.5145C16.2689 31.5145 15.8186 31.9291 15.8186 32.9014V34.5957H15.1823ZM21.0476 34.1024C21.7625 34.1024 22.2343 33.5305 22.2343 32.8085C22.2343 32.0864 21.7625 31.5145 21.0476 31.5145C20.3399 31.5145 19.8609 32.0864 19.8609 32.8085C19.8609 33.5305 20.3399 34.1024 21.0476 34.1024ZM20.9976 34.6815C19.9038 34.6815 19.2175 33.8522 19.2175 32.8085C19.2175 31.7647 19.9395 30.9354 20.9976 30.9354C21.6124 30.9354 22.0056 31.2571 22.1843 31.4788V29.4842H22.8206V34.5957H22.2844L22.1986 34.0881C21.9984 34.3669 21.5552 34.6815 20.9976 34.6815ZM25.7115 34.6815C24.6249 34.6815 23.8671 33.8522 23.8671 32.8085C23.8671 31.7647 24.6249 30.9354 25.7115 30.9354C26.7982 30.9354 27.5631 31.7647 27.5631 32.8085C27.5631 33.8522 26.7982 34.6815 25.7115 34.6815ZM25.7115 34.1024C26.3907 34.1024 26.9125 33.5663 26.9125 32.8085C26.9125 32.0507 26.3907 31.5145 25.7115 31.5145C25.0324 31.5145 24.5176 32.0507 24.5176 32.8085C24.5176 33.5663 25.0324 34.1024 25.7115 34.1024ZM29.2172 34.5957L28.0019 31.0212H28.6524L29.5389 33.8236L30.2538 31.8863L29.9392 31.0212H30.5612L31.5191 33.8236L32.377 31.0212H33.0204L31.8337 34.5957H31.2189L30.5254 32.6512L29.8248 34.5957H29.2172ZM34.6871 34.6815C34.0151 34.6815 33.5933 34.2954 33.3932 33.7307L33.9293 33.5091C34.0437 33.888 34.3082 34.1167 34.7229 34.1167C35.0875 34.1167 35.3305 33.8808 35.3305 33.5877C35.3305 33.2874 35.1518 33.1302 34.7372 32.9657L34.2796 32.7799C33.9079 32.6369 33.6505 32.3009 33.6505 31.8648C33.6505 31.3501 34.0938 30.9354 34.6728 30.9354C35.1732 30.9354 35.5092 31.1857 35.7094 31.6003L35.2018 31.8934C35.0946 31.636 34.9087 31.5002 34.6728 31.5002C34.4441 31.5002 34.2582 31.6718 34.2582 31.8863C34.2582 32.1436 34.4655 32.2509 34.6728 32.3366L35.1947 32.544C35.6236 32.7227 35.9382 33.0587 35.9382 33.5806C35.9382 34.2025 35.4521 34.6815 34.6871 34.6815Z"
                          fill="white" />
                      </svg>
                    </a>
                  </div>
                </template>

              </div>

              <div class="mt-4 md:pr-6 md:mt-12"
                :class="index == 4 ? 'lg:!-mt-6 !-mt-12 relative sm:!-right-12 md:!-right-16 lg:-right-24' : ''">
                <nuxt-img class="mx-auto lg-max:w-9/12" sizes="xs:251px sm:265px md:240px lg:210px xl:251" :class="index == 4 ? 'lg:w-auto !w-7/12' : ''"
                  :src="(bonus as any).imageSrc" :alt="(bonus as any).imageAlt" :width="(bonus as any).imageWidth"
                  :height="(bonus as any).imageHeight" loading="lazy" format="webp" />
              </div>


            </div>

          </div>
        </div>

      </div>

      <!-- price breakdown -->
      <div class="overflow-hidden mx-auto mt-8 max-w-2xl md:mt-10">
        <dl class="space-y-2 text-xs md:text-sm">
          <div v-for="(item, index) in priceBreakdownItems" :key="index"
            class="grid grid-cols-[1fr_auto] gap-4 px-3 py-2.5 md:px-5 md:py-3 bg-[#252525]"
            :class="[(item as any).isTotal ? 'bg-lifeboost-green-50 text-3xl md:text-3xl font-ww-medium font-bold' : '', index === priceBreakdownItems.length - 1 ? '!py-4' : '']">
            <dt :class="(item as any).isTotal ? '' : 'font-ww-medium font-bold md:text-lg text-base text-white'">{{ (item as any).label }}</dt>
            <dd :class="[
              (item as any).isTotal ? 'text-right' : 'flex items-center text-white',
              index === priceBreakdownItems.length - 1 ? 'flex items-center' : ''
            ]"><span class="pr-3 text-sm text-lifeboost-green-50 font-ww-regular"
                :class="index === priceBreakdownItems.length - 1 ? '!text-black' : ''">value</span> <span
                class="text-xl font-ww-regular"
                :class="index === priceBreakdownItems.length - 1 ? '!font-ww-medium font-bold !text-4xl' : ''">{{ (item as
                any).price
                }}</span></dd>
          </div>
        </dl>
      </div>

      <!-- price + CTA -->
      <div class="mt-8 text-center md:mt-10">
        <div class="text-2xl text-white font-ww-bold xl:text-40 md:text-3xl" v-html="ctaHeading"></div>
        <div class="mt-6 text-xl md:text-2xl">
          <span class="text-3xl text-white line-through font-ww-regular xl:text-40 md:text-3xl">{{ originalPrice }}</span>
          <span class="ml-3 text-3xl text-white font-ww-regular xl:text-40 md:text-3xl">{{ discountedPrice }}</span>
        </div>
        <div class="mt-4 text-base text-white" v-html="ctaSubtext"></div>


        <div class="mt-10 mb-8">
          <button @click="scrollTo(scrollTarget, 'bottom')"
            class="flex gap-x-4 justify-center items-center px-4 py-3.5 mx-auto w-10/12 text-lg font-bold text-white rounded-full btn-red sm:w-7/12 md:text-2xl font-ww-medium"
            :style="{ backgroundColor: buttonColor }">
            {{ ctaButtonText }}
            <span>
              <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.8593 0.338767C12.7655 0.43173 12.6911 0.542331 12.6404 0.66419C12.5896 0.78605 12.5635 0.916755 12.5635 1.04877C12.5635 1.18078 12.5896 1.31148 12.6404 1.43334C12.6911 1.5552 12.7655 1.6658 12.8593 1.75877L17.4593 6.35877L1.05859 6.17123C0.793377 6.17123 0.539023 6.27659 0.351487 6.46412C0.163951 6.65166 0.0585938 6.90601 0.0585938 7.17123C0.0585938 7.43645 0.163951 7.6908 0.351487 7.87834C0.539023 8.06587 0.793377 8.17123 1.05859 8.17123L17.4393 8.35877L12.8593 12.9288C12.673 13.1161 12.5685 13.3696 12.5685 13.6338C12.5685 13.898 12.673 14.1514 12.8593 14.3388C13.0466 14.525 13.3001 14.6296 13.5643 14.6296C13.8284 14.6296 14.0819 14.525 14.2693 14.3388L20.6293 7.97877C20.7149 7.89664 20.783 7.79805 20.8295 7.68892C20.876 7.5798 20.9 7.4624 20.9 7.34377C20.9 7.22514 20.876 7.10773 20.8295 6.99861C20.783 6.88949 20.7149 6.7909 20.6293 6.70877L14.2793 0.338767C14.1863 0.245039 14.0757 0.170645 13.9538 0.119876C13.832 0.0691072 13.7013 0.0429688 13.5693 0.0429688C13.4372 0.0429688 13.3065 0.0691072 13.1847 0.119876C13.0628 0.170645 12.9522 0.245039 12.8593 0.338767Z"
                  fill="white" />
              </svg>
            </span>
          </button>
        </div>


      </div>
    </div>
  </section>


</template>

<script setup lang="ts">
import { scrollTo } from '~/composables/scrollTo'

const props = defineProps({
  bannerText: {
    type: String,
    default: 'First Time Order Special'
  },
  mainHeading: {
    type: String,
    default: 'Order Mindflow Today and Get the Morning Upgrade Kit for FREE!'
  },
  introText: {
    type: String,
    default: 'Because this is the first time you\'re trying Mindflow, we want to help you upgrade your morning and your life.<br>When you order Mindflow today as a new customer, you get ALL of the following <strong>INCLUDED</strong>:'
  },
  bonuses: {
    type: Array,
    default: () => [
      {
        title: 'Mindflow (3 bags)',
        value: '$119.97',
        imageSrc: '/assets/images/mindflow-3-product.png',
        imageAlt: 'Mindflow 3 bags',
        imageWidth: 251,
        imageHeight: 203,
        colSpan: 'md:col-span-4 xl:col-span-4',
        numberSvgPath: 'M41.7691 46V22.2646H36.6575V18.7977C40.7912 18.7977 42.258 17.9087 43.3692 14.8862H46.6584V46H41.7691Z'
      },
      {
        title: 'Metal Scooper',
        value: '$25',
        imageSrc: '/assets/images/metal-scooper-mind.png',
        imageAlt: 'Metal Scooper',
        imageWidth: 244,
        imageHeight: 264,
        colSpan: 'md:col-span-4 xl:col-span-4',
        numberSvgPath: 'M36.8351 46V42.6219C36.8351 38.1771 38.0797 35.4658 41.7245 31.6432C45.4581 27.6873 46.5249 25.3315 46.5249 22.4424C46.5249 19.6422 45.547 18.8866 43.9913 18.8866C42.4356 18.8866 41.4578 19.7311 41.4578 21.9535V25.2871H36.8351V22.2646C36.8351 17.2864 39.3243 14.4417 44.1247 14.4417C48.9251 14.4417 51.4142 17.2864 51.4142 22.2646C51.4142 25.9538 49.9029 29.243 45.3692 34.0434C42.4356 37.1548 41.68 38.7105 41.68 40.8884V41.5552H50.9697V46H36.8351Z'
      },
      {
        title: 'Habit-Tracking App',
        value: '$35',
        imageSrc: '/assets/images/habit-tracking-app.png',
        imageAlt: 'Habit Tracking App',
        imageWidth: 219,
        imageHeight: 361,
        colSpan: 'md:col-span-4 xl:col-span-4',
        numberSvgPath: 'M43.858 46.4445C39.0576 46.4445 36.5685 43.6887 36.5685 38.7105V36.1769H41.1911V38.9327C41.1911 41.1551 42.1689 41.9997 43.7246 41.9997C45.2803 41.9997 46.2582 41.244 46.2582 38.4882V35.9547C46.2582 33.0656 45.2803 31.9988 43.0579 31.9988H41.4133V27.554H43.1913C45.0136 27.554 46.1248 26.7539 46.1248 24.2648V21.9979C46.1248 19.7755 45.1025 18.8866 43.6802 18.8866C42.2578 18.8866 41.3244 19.7311 41.3244 21.7757V23.8203H36.7018V22.1757C36.7018 17.1975 39.1909 14.4417 43.858 14.4417C48.525 14.4417 51.0141 17.1531 51.0141 22.1313V23.2425C51.0141 26.5761 49.9474 28.6207 47.5472 29.5097V29.5986C50.1696 30.5764 51.1475 32.8433 51.1475 35.9991V38.7549C51.1475 43.7331 48.6584 46.4445 43.858 46.4445Z',
        appStoreLink: 'https://apps.apple.com/us/app/habits-dont-break-the-chain/id6741651253',
        playStoreLink: 'https://play.google.com/store/apps/details?id=com.app.habitbuilder'
      },
      {
        title: 'Brain Builders Program',
        value: '$30',
        imageSrc: '/assets/images/brain-builders-program.png',
        imageAlt: 'Brain Builders Program',
        imageWidth: 386,
        imageHeight: 222,
        colSpan: 'md:col-span-6 xl:col-span-6',
        numberSvgPath: 'M43.1025 46V40.3551H33.7684V35.9102L42.658 14.8862H47.9918V35.9102H50.3031V40.3551H47.9918V46H43.1025ZM38.2132 35.9102H43.1025V23.7759H43.0136L38.2132 35.9102Z'
      },
      {
        title: 'Everlo Remineralization<br>Coffee Upgrade Drops',
        value: '$40',
        imageSrc: '/assets/images/everlo-mind.png',
        imageAlt: 'Everlo Coffee Upgrade Drops',
        imageWidth: 260,
        imageHeight: 260,
        colSpan: 'md:col-span-6 xl:col-span-6',
        numberSvgPath: 'M42.0802 46.4445C37.2798 46.4445 34.7907 43.5998 34.7907 38.6216V36.1769H39.4133V38.9772C39.4133 41.1996 40.3912 41.9997 41.9469 41.9997C43.5026 41.9997 44.4804 41.1996 44.4804 38.9772V31.9988C44.4804 29.7764 43.5026 28.9319 41.9469 28.9319C40.3912 28.9319 39.4133 29.7764 39.4133 31.9988V32.2655H34.7907L35.6797 14.8862H48.5697V19.331H40.0356L39.6356 26.7539H39.7245C40.6134 25.2871 41.9913 24.487 43.947 24.487C47.5474 24.487 49.3697 27.0206 49.3697 31.5988V38.6216C49.3697 43.5998 46.8806 46.4445 42.0802 46.4445Z'
      }
    ]
  },
  priceBreakdownItems: {
    type: Array,
    default: () => [
      { label: 'Mindflow (3 bags)', price: '$119.97', isTotal: false },
      { label: 'Metal Scooper', price: '$25', isTotal: false },
      { label: 'Habit‑Tracking App', price: '$35', isTotal: false },
      { label: 'Brain Builders Program', price: '$30', isTotal: false },
      { label: 'Everlo remineralization coffee upgrade drops', price: '$40', isTotal: false },
      { label: 'Total', price: '$249', isTotal: true }
    ]
  },
  ctaHeading: {
    type: String,
    default: 'Get the full Morning Upgrade Kit for only…'
  },
  originalPrice: {
    type: String,
    default: '$249'
  },
  discountedPrice: {
    type: String,
    default: '$24.99/bag!'
  },
  ctaSubtext: {
    type: String,
    default: '(That\'s less than $1.00 per serving!)'
  },
  ctaButtonText: {
    type: String,
    default: 'ORDER NOW'
  },
  buttonColor: {
    type: String,
    default: '#F1594B'
  },
  scrollTarget: {
    type: String,
    default: 'products'
  }
})

defineBuilderComponent({
  friendlyName: 'Bundle Offer Section',
  inputs: [
    {
      name: 'bannerText',
      type: 'text',
      defaultValue: 'First Time Order Special'
    },
    {
      name: 'mainHeading',
      type: 'richText',
      defaultValue: 'Order Mindflow Today and Get the Morning Upgrade Kit for FREE!'
    },
    {
      name: 'introText',
      type: 'richText',
      defaultValue: 'Because this is the first time you\'re trying Mindflow, we want to help you upgrade your morning and your life.<br>When you order Mindflow today as a new customer, you get ALL of the following <strong>INCLUDED</strong>:'
    },
    {
      name: 'bonuses',
      type: 'list',
      subFields: [
        {
          name: 'title',
          type: 'richText',
          defaultValue: ''
        },
        {
          name: 'value',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'imageSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
          defaultValue: ''
        },
        {
          name: 'imageAlt',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'imageWidth',
          type: 'number',
          defaultValue: 250
        },
        {
          name: 'imageHeight',
          type: 'number',
          defaultValue: 250
        },
        {
          name: 'colSpan',
          type: 'text',
          helperText: 'CSS classes for column span (e.g., "md:col-span-1 xl:col-span-4")',
          defaultValue: 'md:col-span-1 xl:col-span-4'
        },
        {
          name: 'numberSvgPath',
          type: 'longText',
          helperText: 'SVG path for the number badge',
          defaultValue: ''
        },
        {
          name: 'appStoreLink',
          type: 'url',
          defaultValue: ''
        },
        {
          name: 'playStoreLink',
          type: 'url',
          defaultValue: ''
        }
      ],
      defaultValue: [
        {
          title: 'Mindflow (3 bags)',
          value: '$119.97',
          imageSrc: '/assets/images/mindflow-3-product.png',
          imageAlt: 'Mindflow 3 bags',
          imageWidth: 251,
          imageHeight: 222,
          colSpan: 'md:col-span-4 xl:col-span-4',
          numberSvgPath: 'M41.7691 46V22.2646H36.6575V18.7977C40.7912 18.7977 42.258 17.9087 43.3692 14.8862H46.6584V46H41.7691Z'
        },
        {
          title: 'Metal Scooper',
          value: '$25',
          imageSrc: '/assets/images/metal-scooper-mind.png',
          imageAlt: 'Metal Scooper',
          imageWidth: 244,
          imageHeight: 264,
          colSpan: 'md:col-span-4 xl:col-span-4',
          numberSvgPath: 'M36.8351 46V42.6219C36.8351 38.1771 38.0797 35.4658 41.7245 31.6432C45.4581 27.6873 46.5249 25.3315 46.5249 22.4424C46.5249 19.6422 45.547 18.8866 43.9913 18.8866C42.4356 18.8866 41.4578 19.7311 41.4578 21.9535V25.2871H36.8351V22.2646C36.8351 17.2864 39.3243 14.4417 44.1247 14.4417C48.9251 14.4417 51.4142 17.2864 51.4142 22.2646C51.4142 25.9538 49.9029 29.243 45.3692 34.0434C42.4356 37.1548 41.68 38.7105 41.68 40.8884V41.5552H50.9697V46H36.8351Z'
        },
        {
          title: 'Habit-Tracking App',
          value: '$35',
          imageSrc: '/assets/images/habit-tracking-app.png',
          imageAlt: 'Habit Tracking App',
          imageWidth: 219,
          imageHeight: 361,
          colSpan: 'md:col-span-4 xl:col-span-4',
          numberSvgPath: 'M43.858 46.4445C39.0576 46.4445 36.5685 43.6887 36.5685 38.7105V36.1769H41.1911V38.9327C41.1911 41.1551 42.1689 41.9997 43.7246 41.9997C45.2803 41.9997 46.2582 41.244 46.2582 38.4882V35.9547C46.2582 33.0656 45.2803 31.9988 43.0579 31.9988H41.4133V27.554H43.1913C45.0136 27.554 46.1248 26.7539 46.1248 24.2648V21.9979C46.1248 19.7755 45.1025 18.8866 43.6802 18.8866C42.2578 18.8866 41.3244 19.7311 41.3244 21.7757V23.8203H36.7018V22.1757C36.7018 17.1975 39.1909 14.4417 43.858 14.4417C48.525 14.4417 51.0141 17.1531 51.0141 22.1313V23.2425C51.0141 26.5761 49.9474 28.6207 47.5472 29.5097V29.5986C50.1696 30.5764 51.1475 32.8433 51.1475 35.9991V38.7549C51.1475 43.7331 48.6584 46.4445 43.858 46.4445Z',
          appStoreLink: 'https://apps.apple.com/us/app/habits-dont-break-the-chain/id6741651253',
          playStoreLink: 'https://play.google.com/store/apps/details?id=com.app.habitbuilder'
        },
        {
          title: 'Brain Builders Program',
          value: '$30',
          imageSrc: '/assets/images/brain-builders-program.png',
          imageAlt: 'Brain Builders Program',
          imageWidth: 386,
          imageHeight: 222,
          colSpan: 'md:col-span-6 xl:col-span-6',
          numberSvgPath: 'M43.1025 46V40.3551H33.7684V35.9102L42.658 14.8862H47.9918V35.9102H50.3031V40.3551H47.9918V46H43.1025ZM38.2132 35.9102H43.1025V23.7759H43.0136L38.2132 35.9102Z'
        },
        {
          title: 'Everlo Remineralization<br>Coffee Upgrade Drops',
          value: '$40',
          imageSrc: '/assets/images/everlo-mind.png',
          imageAlt: 'Everlo Coffee Upgrade Drops',
          imageWidth: 260,
          imageHeight: 260,
          colSpan: 'md:col-span-6 xl:col-span-6',
          numberSvgPath: 'M42.0802 46.4445C37.2798 46.4445 34.7907 43.5998 34.7907 38.6216V36.1769H39.4133V38.9772C39.4133 41.1996 40.3912 41.9997 41.9469 41.9997C43.5026 41.9997 44.4804 41.1996 44.4804 38.9772V31.9988C44.4804 29.7764 43.5026 28.9319 41.9469 28.9319C40.3912 28.9319 39.4133 29.7764 39.4133 31.9988V32.2655H34.7907L35.6797 14.8862H48.5697V19.331H40.0356L39.6356 26.7539H39.7245C40.6134 25.2871 41.9913 24.487 43.947 24.487C47.5474 24.487 49.3697 27.0206 49.3697 31.5988V38.6216C49.3697 43.5998 46.8806 46.4445 42.0802 46.4445Z'
        }
      ]
    },
    {
      name: 'priceBreakdownItems',
      type: 'list',
      subFields: [
        {
          name: 'label',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'price',
          type: 'text',
          defaultValue: ''
        },
        {
          name: 'isTotal',
          type: 'boolean',
          defaultValue: false
        }
      ],
      defaultValue: [
        { label: 'Mindflow (3 bags)', price: '$119.97', isTotal: false },
        { label: 'Metal Scooper', price: '$25', isTotal: false },
        { label: 'Habit‑Tracking App', price: '$35', isTotal: false },
        { label: 'Brain Builders Program', price: '$30', isTotal: false },
        { label: 'Everlo remineralization coffee upgrade drops', price: '$40', isTotal: false },
        { label: 'Total', price: '$249', isTotal: true }
      ]
    },
    {
      name: 'ctaHeading',
      type: 'text',
      defaultValue: 'Get the full Morning Upgrade Kit for only…'
    },
    {
      name: 'originalPrice',
      type: 'text',
      defaultValue: '$249'
    },
    {
      name: 'discountedPrice',
      type: 'text',
      defaultValue: '$24.99/bag!'
    },
    {
      name: 'ctaSubtext',
      type: 'richText',
      defaultValue: '(That\'s less than $1.00 per serving!)'
    },
    {
      name: 'ctaButtonText',
      type: 'text',
      defaultValue: 'ORDER NOW'
    },
    {
      name: 'buttonColor',
      type: 'color',
      defaultValue: '#F1594B'
    },
    {
      name: 'scrollTarget',
      type: 'text',
      defaultValue: 'products'
    }
  ]
})
</script>
